import { observer } from 'mobx-react-lite'
import { CollapseWithIcon } from 'shared/ui'
import { type Integration } from 'entities/Integrations'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useIntegrationStoreMemo } from 'pages/settings/pages/integrations/pages/integrationSettings/hooks/useIntegrationStoreMemo'
import { IntegrationZohoSettingsStore } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationZohoSettings/store/IntegrationZohoSettingsStore'
import { IntegrationZohoSettingsSync } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationZohoSettings/ui/IntegrationZohoSettingsSync/IntegrationZohoSettingsSync'
import { CollapseIntegrationSettingsProperty } from 'pages/settings/pages/integrations/pages/integrationSettings/ui/CollapseIntegrationSettingsProperty/CollapseIntegrationSettingsProperty'
import sharedStyles from 'pages/settings/pages/integrations/pages/integrationSettings/ui/styles.module.scss'

type IIntegrationZohoProps = {
  integration: Integration
}

export const IntegrationZohoSettings = observer(({ integration }: IIntegrationZohoProps) => {
  const entities = useEntitiesContext()
  const { collapseStore, syncStore, propertyStore } = useIntegrationStoreMemo(
    IntegrationZohoSettingsStore,
    integration,
    entities
  )

  return (
    <div>
      <CollapseWithIcon
        opened={collapseStore.opened('sync')}
        onClick={collapseStore.onToggle('sync')}
        icon={'arrowHorizontalOutline'}
        title={'Contact syncing'}
        label={syncStore.getLabel}
        headerClassName={sharedStyles.collapseWithIcon}
      >
        <IntegrationZohoSettingsSync store={syncStore} />
      </CollapseWithIcon>
      <CollapseIntegrationSettingsProperty
        collapseStore={collapseStore}
        propertyStore={propertyStore}
      />
    </div>
  )
})
